import { render } from "./Singletrack2022.vue?vue&type=template&id=75810c46"
import script from "./Singletrack2022.vue?vue&type=script&lang=js"
export * from "./Singletrack2022.vue?vue&type=script&lang=js"

import "./Singletrack2022.vue?vue&type=style&index=0&id=75810c46&lang=css"
script.render = render

export default script